// ProtectedRoute.tsx
import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'redux/store';
import { fetchUserInfo } from 'redux/slices/user/userSlice';
import { Box, Stack } from '@mui/material';
import Header from 'components/Common/Header';
import { getAuthData } from 'utils/helpers';
import Lottie from 'lottie-react';
import loading2json from '../loader3.json';
import InactivityTimer from './InactivityTimer';

interface ProtectedRouteProps {
    children?: React.ReactNode;
    hideHeader?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ hideHeader }) => {
    const loading = useSelector((state: RootState) => state.user.loading);
    const authData = getAuthData();
    const { access_token: accessToken, need_change_password } = authData || {};
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        if (accessToken && !need_change_password) {
            dispatch(fetchUserInfo(true));
        }
    }, [need_change_password, accessToken, dispatch]);

    if (!accessToken) {
        // Redirect to the login page if user information is not available
        return <Navigate to="/login" />;
    }

    if (accessToken && loading && !need_change_password) {
        return (
            <Stack width="100%" height="100vh" alignItems="center" justifyContent="center">
                <Stack width="20%" height="20%" alignItems="center" mt="-100px">
                    <Lottie animationData={loading2json} loop={true} />
                </Stack>
            </Stack>
        );
    }

    return (
        <>
            <InactivityTimer />
            {!hideHeader && (
                <Box padding={2}>
                    <Header />
                </Box>
            )}
            <Outlet />
        </>
    );
};

export default ProtectedRoute;
